import { ofType } from 'redux-observable';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';
import config from 'config.json';

const BIDS_QUERY = `
query BidsSearch($criteria: BidCriteria) {
  bids(filter: $criteria, limit: 50) {
    address {
      city
      line1
      line2
      state
      zip
    }
    contacts {
      cellPhone
      email
      isPrimaryContact
      firstName
      name
      lastName
      workPhone
    }
    customer {
      id
      name
    }
    estimatedStartDate
    id
    name
    office {
      id
      name
    }
    priorityNotes
    salesperson {
      id
      calendarColor
      firstName
      lastName
    }
    status {
      name
    }
  }
}
`;

// Action types
const FETCH_AVAILABLE_BIDS = 'FETCH_AVAILABLE_BIDS';
const FETCH_AVAILABLE_BIDS_COMPLETE = 'FETCH_AVAILABLE_BIDS_COMPLETE';
const SEARCH_CUSTOMERS = 'FETCH_CUSTOMERS_BIDS';
const SEARCH_CUSTOMERS_COMPLETE = 'FETCH_CUSTOMERS_BIDS_COMPLETE';
const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA_BIDS';

const DEFAULT_STATE = {
  bids: [],
  customers: {
    customers: [],
    loading: false
  },
  form: {
    bidTypes: [],
    offices: [],
    salespeople: []
  },
  loading: false
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_AVAILABLE_BIDS:
      return {
        ...state,
        bids: [],
        loading: true
      };
    case FETCH_AVAILABLE_BIDS_COMPLETE:
      return {
        ...state,
        ...payload,
        loading: false
      };
    case SEARCH_CUSTOMERS:
      return {
        ...state,
        customers: {
          customers: [],
          loading: true
        }
      };
    case SEARCH_CUSTOMERS_COMPLETE:
      return {
        ...state,
        customers: {
          customers: payload.customers,
          loading: false
        }
      };
    case UPDATE_SEARCH_CRITERIA:
      return {
        ...state,
        form: {
          ...state.form,
          ...payload
        },
        loading: true
      };
    default:
      return state;
  }
}

// Action creators
export const fetchAvailableBids = () => ({
  type: FETCH_AVAILABLE_BIDS
});

const fetchAvailableBidsComplete = (bids) => ({
  type: FETCH_AVAILABLE_BIDS_COMPLETE,
  payload: { bids }
});

export const searchCustomers = (query) => ({
  type: SEARCH_CUSTOMERS,
  payload: { query }
});

const searchCustomersComplete = (customers) => ({
  type: SEARCH_CUSTOMERS_COMPLETE,
  payload: { customers }
});

export const openBid = (bidId) => {
  window.open(`${config.versaItRoot}display.asp?key=6085&fo=basic%20display&rm=page&xID=${bidId}`);
};

export const updateSearchCriteria = (criteria) => ({
  type: UPDATE_SEARCH_CRITERIA,
  payload: criteria
});

// Epics
export const fetchAvailableBidsEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_AVAILABLE_BIDS, UPDATE_SEARCH_CRITERIA),
  debounceTime(300),
  switchMap(() => {
    const { bidTypes, customerId, offices, query, salespeople } = state$.value.searchBids.form;

    const criteria = {
      jobs_none: {},
    };
    if (query) {
      criteria.name_contains = query;
    }
    if (bidTypes.length) {
      criteria.bidType_in = bidTypes.map((t) => t.value);
    }
    if (customerId) {
      criteria.customer = { id: customerId };
    }
    if (offices.length) {
      criteria.office = { name_in: offices.map((o) => o.name) };
    }
    if (salespeople.length) {
      criteria.salesperson = { id_in: salespeople.map(s => s.id) };
    }

    return JobProApi
      .post('/graphql', null, {
        query: BIDS_QUERY,
        variables: {
          criteria,
        },
      })
      .then(response => response.data.bids);
  }),
  map(fetchAvailableBidsComplete),
);

export const searchCustomersEpic = (action$) => action$.pipe(
  ofType(SEARCH_CUSTOMERS),
  debounceTime(300),
  switchMap(({ payload }) => {
    const { query } = payload;
    return JobProApi.customers.search({
      query
    }, {
        fields: 'id,name'
      });
  }),
  map(searchCustomersComplete),
);
